import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { Card, Col, Row, Tabs, Tab } from 'react-bootstrap';

import { fetchEpstScoreSheetByCertification, updateEpstScoreCertificationSection } from 'api/certifications/epst/results';

import { handleApiError, successNotification } from 'utils';

import styles from './epstEvaluation.module.scss';
import WritingQuestion from './WritingQuestion';
import SpeakingQuestion from './SpeakingQuestion';
import Questions from './Questions';

const ViewEpst = () => {
	const token = useSelector(state => state.authentication.user?.token);

	const location = useLocation();
	const navigate = useNavigate();
	const { certification } = location.state || {};

	
	const [grammars, setGrammars] = useState([]); 
	const [readings, setReadings] = useState([]); 
	const [listenings, setListenings] = useState([]); 
	const [writings, setWritings] = useState([]); 
	const [speakings, setSpeakings] = useState([]); 

	const [activeTab, setActiveTab] = useState("grammar");


	useEffect(() => {
		if (!certification.id) navigate(-1);
		else {
			loadCertificationByIdSectionId(1);
			loadCertificationByIdSectionId(2);
			loadCertificationByIdSectionId(3); 
			loadCertificationByIdSectionId(4);
			loadCertificationByIdSectionId(5); 
		}
	}, [certification, navigate]);

	const loadCertificationByIdSectionId = async (sectionId) => {
		try {
			const { data } = await fetchEpstScoreSheetByCertification(certification.id, sectionId, token);
			if(sectionId === 1) setGrammars(data.message);
			if(sectionId === 2) setReadings(data.message);
			if(sectionId === 3) setListenings(data.message);
			if(sectionId === 4) setWritings(data.message);
			else if(sectionId === 5) setSpeakings(data.message);
		} catch (error) {
			handleApiError(error);
		}
	}


	return (
		<Card>
			<Card.Body className="overflow-hidden p-lg-5">
				<h5 className="text-primary">Ver Examen</h5>

				{/* Información general */}
				<Row className="mt-3">
					{/* Columna izquierda */}
					<Col xs={12} md={6}>
						<p className={styles.rowUserData}>
							<strong>Nombre:</strong> {certification.name}
						</p>
						<p className={styles.rowUserData}>
							<strong>Email:</strong> {certification.email}
						</p>
						<p className={styles.rowUserData}>
							<strong>Colegio:</strong> {certification.college_name}
						</p>
					</Col>

					{/* Columna derecha */}
					<Col xs={12} md={6}>
						<p className={styles.rowUserData}>
							<strong>Tipo usuario:</strong> {certification.candidate_type}
						</p>
						<p className={styles.rowUserData}>
							<strong>Tipo certificación:</strong> {certification.certification_type}
						</p>
						<p className={styles.rowUserData}>
							<strong>Fecha finalizado:</strong> {certification.completed_date}
						</p>
					</Col>
				</Row>
				{/* Tabs para cada seccion */}
				<Tabs 
					defaultActiveKey="grammar"
					activeKey={activeTab}
					onSelect={(k) => setActiveTab(k)}
					className="mb-3 mt-3">
					{/* Grammar Tab */}
					<Tab eventKey="grammar" title="Grammar" className="p-3">
						{grammars.length === 0 ? (
							<Row><Col>No hay respuestas para esta sección.</Col></Row>
						) : (
							<>
								{grammars.map(question => (
									<Questions
										key={question.question_id}
										questionData={question}
									/>
								))}
							</>
						)}
					</Tab>

					<Tab eventKey="reading" title="Reading" className="p-3">
						{readings.length === 0 ? (
							<Row><Col>No hay respuestas para esta sección.</Col></Row>
						) : (
							<>
								{readings.map(question => (
									<Questions
										key={question.question_id}
										questionData={question}
									/>
								))}
							</>
						)}
					</Tab>

					<Tab eventKey="listening" title="Listening" className="p-3">
						{listenings.length === 0 ? (
							<Row><Col>No hay respuestas para esta sección.</Col></Row>
						) : (
							<>
								{listenings.map(question => (
									<Questions
										key={question.question_id}
										questionData={question}
									/>
								))}
							</>
						)}
					</Tab>
					
					<Tab eventKey="writing" title="Writing" className="p-3">
						{writings.length === 0 ? (
							<Row><Col>No hay respuestas para esta sección.</Col></Row>
						) : (
							<>
								{writings.map(question => (
									<WritingQuestion
										key={question.question_id}
										questionData={question}
									/>
								))}
							</>
						)}
					</Tab>

					{/* Speaking Tab */}
					<Tab eventKey="speaking" title="Speaking" className="p-3">
						{speakings.length === 0 ? (
							<Row><Col>No hay respuestas para esta sección.</Col></Row>
						) : (
							<>
								{speakings.map(question => (
									<SpeakingQuestion
										key={question.question_id}
										questionData={question}
									/>
								))}
							</>
						)}
					</Tab>
				</Tabs>
				<div className="d-flex justify-content-between" >
					<button className="btn btn-outline-secondary" onClick={() => navigate(-1)}>
						← Regresar
					</button>
				</div>

			</Card.Body>
		</Card>
	);
};

export default ViewEpst;